/** 来源：crm/foodbuy/market；统一为规范 03 的五种语义 tone。 */
export type Tone = 'neutral' | 'info' | 'success' | 'warning' | 'danger'

export const badgeToneClasses: Record<Tone, string> = {
  neutral: 'bg-[var(--color-soft)] text-[var(--color-muted)]',
  info: 'bg-[var(--color-primary-soft)] text-[var(--color-primary)]',
  success: 'bg-[var(--color-success-soft)] text-[var(--color-success-ink)]',
  warning: 'bg-[var(--color-warning-soft)] text-[var(--color-warning-ink)]',
  danger: 'bg-[var(--color-danger-soft)] text-[var(--color-danger-ink)]'
}

export const alertToneClasses: Record<Tone, string> = {
  neutral: 'border-[var(--color-line)] bg-[var(--color-soft)] text-[var(--color-ink)]',
  info: 'border-[var(--color-primary)] bg-[var(--color-primary-soft)] text-[var(--color-ink)]',
  success: 'border-[var(--color-success)] bg-[var(--color-success-soft)] text-[var(--color-ink)]',
  warning: 'border-[var(--color-warning)] bg-[var(--color-warning-soft)] text-[var(--color-ink)]',
  danger: 'border-[var(--color-danger)] bg-[var(--color-danger-soft)] text-[var(--color-ink)]'
}
